<template>
  <div class="tuiguang-details">
    <!-- 头部组件 -->
    <Header />

    <!-- 主体内容区域 -->
    <main class="details-content">
      <div class="container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{
              name: 'home', params: {
                activeName: '8',
              },
            }">商家推广</el-breadcrumb-item>
            <el-breadcrumb-item>推广详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- 商品信息卡片 -->
        <div class="product-card">
          <h1 class="product-title">{{ tuiguangDetail.title }}</h1>

          <div class="product-meta">
            <span class="category">分类：{{ tuiguangDetail.goodscategory_name }}</span>
            <span class="publish-time">发布时间：{{ tuiguangDetail.create_time }}</span>
          </div>

          <div class="contact-info">
            <div class="seller-info">
              <img :src="tuiguangDetail.avatar" alt="卖家头像" class="seller-avatar">
              <span class="seller-name">{{ tuiguangDetail.nickname }}</span>
            </div>

            <div class="action-buttons">
              <el-button class="contact-btn" type="primary" plain>在线沟通</el-button>
              <el-button class="promote-btn" type="primary" @click="goTuiguang">我要推广</el-button>
            </div>
          </div>
        </div>

        <!-- 商品详情 -->
        <div class="product-details">
          <h2 class="section-title">商品详情</h2>

          <div class="details-content" style="background-color: #fff;">
            <div class="product-description" v-html="tuiguangDetail.product_details">
            </div>
            <!-- <div class="product-image">
              <img src="https://picsum.photos/800/600" alt="商品图片">
            </div> -->
          </div>
        </div>
      </div>
    </main>

    <!-- 底部组件 -->
    <Footer />
  </div>
</template>

<script>
// 导入Header和Footer组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'

export default {
  name: 'TuiguangDetails',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      // 可以在这里添加数据
      tuiguangDetail: {}
    }
  },
  mounted() {
    this.getTuiguangDetail();
  },
  methods: {
    goTuiguang() {
      this.$router.push({
        path: '/FabuTuiguang',
      })
    },
    // 获取推广详情
    getTuiguangDetail() {
      let aid = this.$route.query.aid;
      this.$api.getTuiguangDetail({
        aid: aid,
      }).then(res => {
        this.tuiguangDetail = res;
      }).catch(err => {
        this.$message.error(err);
      })
    }
  }
}
</script>

<style scoped>
.tuiguang-details {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.details-content {
  flex: 1;
  padding: 20px 0;
  background-color: #f5f5f5;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.breadcrumb {
  margin-bottom: 20px;
  padding: 10px 0;
  background-color: white;
  border-radius: 4px;
  padding: 15px 20px;
}

.product-card {
  background-color: white;
  border-radius: 4px;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.product-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.product-meta {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.contact-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.seller-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.seller-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.seller-name {
  font-weight: bold;
  color: #333;
}

.action-buttons {
  display: flex;
  gap: 15px;
}

.contact-btn,
.promote-btn {
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 14px;
}

.promote-btn {
  background-color: #286CED;
  border-color: #286CED;
}

.product-details {
  background-color: white;
  border-radius: 4px;
  padding: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  text-align: left;
}

.details-content {
  line-height: 1.8;
  color: #333;
}

.product-description {
  margin-bottom: 30px;
  font-size: 16px;
}

.product-image {
  text-align: center;
  margin-top: 30px;
}

.product-image img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>